// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"63":"12adce07","220":"c9a7c2ee","665":"f2aa1b05","877":"a030b188","950":"7873491c"}[chunkId] + ".chunk.js";
};